import React from 'react';
import useRole from '../hooks/userRole';
import UnauthorizedScreen from '../screens/UnauthorizedScreen';

const withRoleGuard = (Component, task, requireCRUD = false, parentTask = null, hideIfUnauthorized = false, table = 'ss') => {
    return function GuardedScreen(props) {
        const { hasAccess, hasOptionAccess } = useRole();

        const allowed = parentTask
            ? hasOptionAccess(parentTask, task, table, requireCRUD)
            : hasAccess(task, table, requireCRUD);

        if (!allowed) return hideIfUnauthorized ? null : <UnauthorizedScreen />;
        return <Component {...props} />;
    };
};

export default withRoleGuard;